import EventBase from './EventBase'
import EventID from './EventID'

/**
 * 110    打开指定网页
 */

export default class EventOpenUrl extends EventBase {
  /**
   * 打开指定网页构造函数
   */
  constructor(url?: string) {
    super()
    this.Parameter = url ? [url] : ['']
  }
  /**
   * 事件ID
   */
  Code = EventID.OpenUrl
  // #region 类的相关参数都在这里
  /**
   * 指定网址
   */
  get Url() {
    return this.Parameter?.[0] || ''
  }
  set Url(value) {
    this.Parameter && (this.Parameter[0] = value.toString())
  }
  //   // #endregion
  /**
   * 获取显示信息
   */
  /// <returns></returns>
}
